import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { map } from 'rxjs';
import { RoleUser } from '../models';
import { MenuService } from '../../core/header/menu/menu.service';
import { PermissionsService } from './permissions.service';
import { MainUserService } from './main-user.service';
import {SettingsService} from "./settings.service";

@Injectable({
  providedIn: 'root',
})
export class PermissionsGuard  {
  constructor(
    private authService: AuthService,
    private permissionsService: PermissionsService,
    private menuService: MenuService,
    private mainUserService: MainUserService,
    private settings: SettingsService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const user = this.mainUserService.getUserData();
    const permissionKey = next.data['permissionId'];
    if (user.role !== RoleUser.OutletUser) {
      return true;
    }
    return this.authService.getApplicationUserPermissions(user.userId).pipe(
      map((per) => {
        const canActivate =
          this.permissionsService.isAvailableForUser(permissionKey);
        if (!canActivate) {
          this.permissionsService.setUserPermissionError();
          this.menuService.refreshMenu(this.settings.isMobileSize());
        }
        return canActivate;
      })
    );
  }
}
